if (typeof TranslationTags == 'undefined') var TranslationTags = [];

var allowedFiles  = new Array ('image/jpg', 'image/jpeg', 'image/gif', 'image/png', 'image/bmp', 'image/tiff', 'application/pdf', 'application/msword', 'text/plain');
var __userForm    = null;
var loadDashboard = false;

var MIN_FREQUENCY = 2;
var MAX_FREQUENCY = 24;

if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

$(function () {
    /* Load TAB */
    const tab = $_GET('tab');
    const params = {
        autoship_updated: $_GET('autoship_updated'), // MIS-1345: Param to show info modal when an autoship has updated the card from custom auth
        id_pet: $_GET('id_pet'),
        checkout_id_address: $_GET('checkout_id_address')
    }
    const valuedParams = Object.fromEntries(Object.entries(params).filter(([key, value]) => !!value));

    if (tab) {
        const res= tab.split("_");
        const menu = res[0] ?? 'false';
        const submenu = res[1] ?? false;
        if (menu) {
            changeUserMenu(menu, submenu, true, valuedParams);
        }
    } else  {
        $('.user--menu-items').find('li').first().click();
    }

    window.onpopstate = function(event) {
        const tab = $_GET('tab');
        const res = tab.split("_");
        const menu = res[0] ?? false;
        const submenu = res[1] ?? false;
        if (menu) {
            showMenu(menu, submenu);
        }
    };

    if (MOBILE) {
      /* menu mobile */
        $('#user-menu-trigger').click(function() {
            $(this).closest('aside.user--menu').toggleClass('is-open scale-in-center');
            $('#user-menu-overlay').toggleClass('active');
            $('body').toggleClass('fixed');
        });
        $('.user--menu-items > li').click(function() {
            $(this).closest('aside.user--menu').toggleClass('is-open scale-in-center');
            $('#user-menu-overlay').toggleClass('active');
            $('body').toggleClass('fixed');
        });
        $('#user-menu-overlay').click(function() {
            $('aside.user--menu').toggleClass('is-open scale-in-center');
            $('#user-menu-overlay').toggleClass('active');
            $('body').toggleClass('fixed');
        });
    }

    //Attach autoship events on menu loaded
    $("#menu-content").on("usermenu:loaded", function(ev, menu){
        if(menu != "autoship") return;
        initNumberSelectors();
    });

});

//FIX: Misleading calculation
function updateTotalPrice(id_autoshipping){
    var new_total_price = 0;
    var $autoship_block = $("#autoshipping-"+id_autoshipping);
    $(".order--single-item .order-item--price", $autoship_block).each(function(){
        new_total_price += $(this).data("unitPrice") * $(".order-item--quantity input", $(this).closest(".order--single-item")).val();
    });
    new_total_price *= .95;
    asyncFormatMoney(new_total_price).then(function(res){
        $(".order-data.total-amount .data-value", $autoship_block).text(res);
    });
}

var starRating = 0;

/* RECOVER PAGE */
function sendRecoverPass(form) {
    if(!checkPasswordLength(form, 'errorPassword')){
        return false;
    }
    $.post(form.action,
            $(form).serialize(),
            function (result) {
                if (!result || !result.error) {
                    document.location.href = '/user/';
                } else {
                    $(form.elements).filter(':not(:submit)').addClass(INPUT_KO);
                    if ($('#errorPassword').length > 0) {
                        $('#errorPassword td:nth-child(2) span').text(result.error);
                        $('#errorPassword').show();
                    }
                }
            },
            'json');
    return false;
}

/*THANK YOU PAGE MISCOTA*/
function UserPetForm(form) {
    if (UserPetForm.template == null) {
        var template = $('#userPetTemplate').children();
        template.unwrap();
        UserPetForm.template = template.detach();
    }
}

UserPetForm.template = null;

UserPetForm.loadPets = function () {
    $.post('/modules/user/getUserLoggedPets',
            function (result) {
                if (!result || result.length == 0) {
                    UserPetForm.copyTemplate();
                } else {
                    for (var idx = 0; idx < result.length; ++idx) {
                        var pet = result[idx];
                        var template = UserPetForm.copyTemplate();
                        for (var field in pet) {
                            template.find('[name="'+field+'\[\]"]').val(pet[field]);
                        }
                        template.find('select[name="type_animal_select"]').val(pet.type_animal).change();
                    }
                }
            },
            'json');
};

UserPetForm.copyTemplate = function () {
    var newTemplate = UserPetForm.template.clone();
    newTemplate.insertBefore($('.userPetOptions'));
    return newTemplate;
};

UserPetForm.submit = function (form) {
    var serialized = $(form).serialize();
    var loading    = insertLoadingImg(form.submit);
    var span = $(form.submit).nextAll('span');
    if (span.length == 0) span = $(' <span />').insertAfter(form.submit);
    span.removeClass('errorSpan').removeClass('correctSpan').empty();
    form.submit.disabled = true;
    for (var i = form.elements.length - 1; i >= 0; i--) {
      if(form.elements[i].name == 'name[]' && form.elements[i].value == ''){
        $(form.elements[i]).addClass(INPUT_KO);
        form.submit.disabled = false;
        loading.remove();
        return false;
      }
    };

    $(form.elements).removeClass(INPUT_KO);
    $.post(form.action,
           serialized,
           function (result) {
               loading.remove();
               form.submit.disabled = false;

               var dl_label = '';
               $('.formPetsContainer select[name="type_animal_select"] option:selected').each(function(){
                if(dl_label == '') dl_label = $(this).text();
                else dl_label += '/'+$(this).text();
               });

               if (!result) {
                  $('.errorSpan').empty();
                   span.addClass('correctSpan').text(__('changes_saved'));
                   pushDatalayer('eventGA', 'Anadir Mascota', 'Click', dl_label, 1, 1);
               } else {
                   var errores = false;
                   if (result.error == 'login-required')
                       document.location.href = '/user/login';

                   $('.errorSpan').empty();
                   for (var idx in result) {
                       var res = result[idx];
                       if (res.error) {
                           errores = true;
                           for (var key in res.error) {
                               var element = form.elements[key+"[]"];
                               if (element.name == undefined) element = element[idx];
                               $(element).addClass(INPUT_KO);
                               var errorSpan = $(element).closest('.contentText').find('.errorSpan');
                               if (errorSpan.length > 0) errorSpan.text(res.error[key]);
                           }
                       }
                   }

                   if (errores)
                      span.addClass('errorSpan').text(__('form_errors'));
                   else if (result.error)
                      span.addClass('errorSpan').text(result.error);
                   else{
                      $('.errorSpan').empty();
                      span.empty().addClass('correctSpan').text(__('changes_saved'));
                      pushDatalayer('eventGA', 'Anadir Mascota', 'Click', dl_label, 1, 1);
                   }
               }
           },
           'json');
    return false;
};

/* --- User Zone --- */
/* ----------------- */

function changeUserMenu( menu, submenu, replace, params = {} ) { //, aParam, idPet, ){
    const $content = $("#menu-content");
    const queryParams = new URLSearchParams(params);

    if ($content.data("menu") !== menu) { //Only push or replace history if it's from a different menu

        const url = `${document.location.pathname}?tab=${menu}${(submenu ? `_${submenu}` : '')}${location.hash}${queryParams.toString() ? '&' + queryParams.toString() : ''}`;

        const historyStateFn = !!replace ? history.replaceState : history.pushState;
        historyStateFn.call(history, null, null, url);
    }

    if (params?.autoship_updated === '1') {  // MIS-1345: Show modal in user zone if URL has param 'autoship_updated=1' (card updated for an autoship order, redirected from custom auth)
        let content = '<div class="flex-row mt20 autoship-updated-modal"><svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><circle class="checkmark-circle" cx="25" cy="25" r="25" fill="none"/><path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg> <p class="ml20"><span style="display: block; margin-bottom: 8px;">' + __("autoship_card_updated") + '</span><b>' + __("your_order_in_progress") + '</b></p></div>';
        setTimeout(function () {
            contentModal(content);
        }, 1000);
    }

    if ($('#section-' + menu).length === 0 || (menu === 'resume' && loadDashboard)) {
        const loadingDiv = ContentLoading();
        const formData = new FormData();
        queryParams.forEach((value, key) => formData.append(key, value));
        const parsedParams = new URLSearchParams(formData);
        const paramsUrl = parsedParams.toString() === '' ? '' : `/${parsedParams}`;

        $.post(`/modules/user/printUserMenu/${menu}${paramsUrl}`, function (result) {
            if (!result) {
                document.location.reload();
            }

            const cleanUrl = `${document.location.pathname}?tab=${menu}${(submenu ? `_${submenu}` : '')}${location.hash}`;
            history.replaceState(null, null, cleanUrl);

            $content.data("menu", menu);
            loadingDiv.remove();
            $content.append(result);
            initElements(menu);
            showMenu(menu, submenu);
            $content.trigger("usermenu:loaded", [menu, submenu]);
            //Trigger hash scroll, if present
            if (location.hash && location.hash.indexOf('&') === -1 && $(location.hash).offset()) {
                $(window).scrollTop($(location.hash).offset().top - 180);
            }
        });
    }
    showMenu(menu, submenu);

}

function showMenu(menu, submenu){
    $('.user--menu-items li').removeClass('active');
    $('.user--tab-items li').removeClass('active');
    $('.user--tab-items li:first-of-type').addClass('active');

    $('.user-section').hide();
    $('#option-'+menu).addClass('active');
    $('#section-'+menu).show();
    pushDatalayer('eventGA', 'Menu Personal', 'Click', $('#option_'+menu).text(), 1, 1);

    if (typeof submenu != 'undefined' && submenu) changeUserSubMenu(submenu);
    else $('#section-'+menu).find('.user--tab-items').find('li').first().click();
    $('html').scrollTop(0);
}

function changeUserSubMenu(submenu){
    $('.user--tab-items li').removeClass('active');
    $('.user-tab-content').hide();

    $('#option-'+submenu).addClass('active');
    $('#section-'+submenu).show();

    $(window).scrollTop(0);

    pushDatalayer('eventGA', 'Sub-Menu Personal', 'Click', $('#suboption_'+submenu).text(), 1, 1);
}

function initElements(menu){
    var div = $('#section-'+menu);
    switch(menu) {
        case 'resume':
            break;

        case 'account':
            $(div).on('click', '.user-box--add', function() {
                if($(div).find('.add-address').length > 0) cancelAddressForm();
                $(this).parent('.tab-container--wrapper').next('.tab-container--wrapper.new-tab').css('display', 'flex');
                $(this).closest('.tab-container').find('.buttons button').show();
                smoothScrollTo('.tab-container--wrapper.new-tab', null, -80);
            });

            const postcodeInputs = div[0].querySelectorAll('input[name="postcode"]');
            postcodeInputs.forEach(input => initPostalCodeInput(input, CODE_COUNTRY));

            const $inputNewsletterStatus = div[0].querySelector('#email-subscription');
            const $inputSmsStatus = div[0].querySelector('#phone-subscription');

            $(div).find('.form input').on('keyup change', function(e) {
                var input = $(this);
                if (input.val().length > 0) {
                    input.addClass('filled');
                    $(input).closest('div[class^="single-"]').removeClass('validation-wrong');
                } else if ($(input).attr('name') != 'password'){
                    input.removeClass('filled');
                }
                if ($(input).attr('name') == 'password') {
                    $('#input-repeat-password').show();
                }
                let attrName = $(input).attr('name');

                switch(attrName) {
                    case 'user_save_cards':
                        if (input.checked !== input.attr('data-initial-state')) {
                            input.closest('.tab-container').find('.buttons button').show();
                        } else {
                            input.closest('.tab-container').find('.buttons button').hide();
                        }
                        input.closest('.tab-container').find('.buttons button').show();
                        break;
                    case 'newsletter': //email
                    case 'newsletter_sms':
                        if (($inputNewsletterStatus.checked ? '1' : '0') === $inputNewsletterStatus.dataset.original
                            && ($inputSmsStatus.checked ? '1' : '0') === $inputSmsStatus.dataset.original)
                        {
                            input.closest('.tab-container').find('.buttons button').hide();
                        } else {
                            input.closest('.tab-container').find('.buttons button').show();
                        }
                        break;
                }
            });

            $(div).find('.view-password').click(function() {
                if( $(div).find('input[name="password"]').prop('type') == 'password' ) {
                    $(div).find('input[name*="password"]').prop('type', 'text');
                } else {
                    $(div).find('input[name*="password"]').prop('type', 'password');
                }
            });
            $(".custom-select").each(function(){
                new CustomSelect(this);
            });
            break;

        case 'points':
            if(typeof show_reward_points !== 'undefined'){
                if(show_reward_points !== null) addUserPointsModal();
            };
            break;

        case 'orders':
            $(div).find('.user-box--header').on('click', '.header-trigger, .custom-box--invisible-trigger', function() {
                $(this).parent('.user-box--header').toggleClass('is-open');
            });
            $('.order--more-items').click(function() {
                $(this).parents('.user-box').removeClass('has-more');
            });
            /* Product Review @ User Zone */
            initStars();
            break;

        case 'autoship':
            $(div).find('.user-box--header').on('click', '.custom-box--invisible-trigger, .header-trigger', function() {
                $(this).parent('.user-box--header').toggleClass('is-open');
                $(this).parents('.user-box').toggleClass('config-on');
                var self = $(this);
                /* Updates url based on item cat */
                customUrlItemBased(self);
            });

            $('.is-mobile .autoship-info .close-button').click(function() {
                fixBodyScroll(true);
                $(this).parents('.user-box.autoship-info').toggleClass('is-open');
                $(this).siblings('.right-col').children('.autoship-benefits').slideToggle(200);
            });

            qtyInputs = $(div).find('.product-quantity input');
            $(qtyInputs).each(function(i, input) {
                if ($(input).val() == 1) $(input).parents('.product-quantity').addClass('minus-disabled');
            });
            break;

        case 'interests':
            let horseBtn = document.getElementById('horse');

            $('.user-box--add').on('click', function() {
                cancelInterestForm();
                togglePetTypeOptions(horseBtn, 'horse', false);
                $(this).parent('.tab-container--wrapper').next('.tab-container--wrapper.new-tab').css('display', 'flex');
                $(this).closest('.tab-container').find('.buttons button').show();
                smoothScrollTo("#content-form", null, 46);
                document.getElementById('pet-name').focus();
                $('#uploadImg').removeAttr("style");
                $('#id_pet').val(0);
                if($("#uploadImg").hasClass("has-image")) $("#uploadImg").removeClass("has-image");
            });

            $(div).find('.form input').on('keyup change', function(e) {
                var input = $(this);
                if (input.val().length > 0) {
                    input.addClass('filled');
                    $(input).closest('div[class^="single-"]').removeClass('validation-wrong');

                } else if (($(input).attr('name') != 'password') || ($(input).attr('type') == 'date')) {
                    input.removeClass('filled');
                }
            });

            $(".custom-select").each(function(){
                new CustomSelect(this);
            });

            $('.interest-selector').on('click', '.button-interest', function() {
                var activeId =  $(this).attr('id');
                $('.button-interest').removeClass('is-selected');
                $('.specific-inputs > div').removeClass('is-active');
                $(this).closest('.new-tab').attr('class', 'tab-container--wrapper new-tab'); // remove all interest classes but not defaults!.
                $(this).closest('.new-tab').addClass(activeId); // add interest classe to match placeholder image.
                $('#specific-inputs').addClass('is-visible');
                $(this).addClass('is-selected');
                $('.specific-inputs > #'+activeId+'-inputs').addClass('is-active');
                $('.specific-inputs > div input').prop('disabled', true);
                $('.specific-inputs > #'+activeId+'-inputs input').prop('disabled', false);
            });

            $('#uploadImg').on('click', function(){ $('#imgupload').click(); });
            //Load image preview
            $("#imgupload").on("change", function(){
                var $preview = $("#uploadImg");
                $preview.addClass('has-image');
                var fr = new FileReader();
                fr.addEventListener("load", function(e) {
                    $preview.attr("style", "background-image: url("+ e.target.result +")")
                });
                fr.readAsDataURL(this.files[0]);
            });

            if (document.getElementById("id-pet-url")) {
                let idPet = document.getElementById("id-pet-url").value;
                if (idPet) {
                    editPet(idPet);
                }
            }

            /* MIS-3895 : Limitar datepicker pet-birthdate a maxdate today */
            $('#section-interests input[name="pet-birthdate"]').attr('max',new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0]);
            /* END MIS-3895 : Limitar datepicker pet-birthdate a maxdate today */
    }

    initCopyCodeButtons();
    initSmoothScrollEvents();
}


/* ACCOUNT DETAILS */
function editUserInfo(){
    var $form = $('#account-form');
    $form.removeClass('form-disabled');
    $form.find('[data-toggle="edit-profile"]').hide();
    $form.find('[data-toggle="save-edit-profile"]').show();
    $form.find('[data-toggle="cancel-edit-profile"]').show();
    $form.find('input').attr('disabled', false);
    $form.find('input').first().focus();
}

function cancelEditUserInfo(){
    var $form = $('#account-form');
    $form.addClass('form-disabled');
    $form.find('[data-toggle="edit-profile"]').show();
    $form.find('[data-toggle="save-edit-profile"]').hide();
    $form.find('[data-toggle="cancel-edit-profile"]').hide();
    $form.find('input').each(function(){
        if($(this).attr('type') == 'checkbox'){
            $(this).prop('checked', $(this).attr('data-original') == '1');
        }else if($(this).attr('type') == 'radio'){
            $(this).prop('checked', $(this).attr('data-original') == $(this).val());
        }else{
            $(this).val($(this).attr('data-original')).change();
        }
    });
    $form.find('input').attr('disabled', true);
    $('#input-repeat-password').hide();
}

function updateUserInfo(form){
    const loadingDiv = ContentLoading();
    if (isEmpty(form.name.value)
        || isEmpty(form.lastname.value)
        || isEmpty(form.email.value)
        || (form['tax-id'] && showTaxId() && REQUIRED_TAX_ID_FIELD && isEmpty(form['tax-id'].value))
    ) {
        contentLoadingKO(loadingDiv, __('required_fields'));
        return false;
    }

    const nifValue = form['tax-id'] ? form['tax-id'].value : '';
    if (showTaxId() && !isEmpty(nifValue)) {
        const taxIdValidation = validateTaxId(COUNTRY, nifValue);
        if (taxIdValidation.error) { // NIF KO
            contentLoadingKO(loadingDiv, taxIdValidation.error);
            return false;
        }
    }

    const minLength = 7;
    const pass = form.password.value;
    if (!isEmpty(pass) && !checkPasswordLength(form, '', minLength)) {
        const _error = 'Password error: ' + __('enter_at_least_n_chars', minLength);
        contentLoadingKO(loadingDiv, _error);
        return false;
    }
    $.post(form.action,
        $(form).serialize(),
        function (result) {
            if (result.error) {
                contentLoadingKO(loadingDiv, result.error);
            } else {
                const $form = $('#account-form');
                $form.addClass('form-disabled');
                $form.find('[data-toggle="edit-profile"]').show();
                $form.find('[data-toggle="save-edit-profile"]').hide();
                $form.find('[data-toggle="cancel-edit-profile"]').hide();
                $form.find('input').each(function () {
                    $(this).attr('data-original', $(this).val());
                });

                $form.find('input[name*="password"]').attr('data-original', '').val('');
                $form.find('input').attr('disabled', true);
                $('#input-repeat-password').hide();
                contentLoadingOK(loadingDiv, result.success);
                loadDashboard = true;
            }
        },
        'json'
    );

    return false;
}


/* ACCOUNT ADDRESS */
async function setDefaultAddress(id_address) {
    const loadingDiv = ContentLoading();
    try {
        await fetch('/user_address_form/setDefaultAddress?ajax=true', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({ id_address })
        });

        const addressSection = document.querySelector('#section-account-address');
        const userBoxes = addressSection.querySelectorAll('.user-box');
        userBoxes.forEach(box => {
            box.classList.remove('main-option');
            box.querySelector('.check_default').classList.remove('hidden');
        });

        const selectedBox = document.querySelector(`[id_address="${id_address}"]`);
        selectedBox.classList.add('main-option');
        selectedBox.querySelector('.check_default').classList.add('hidden');

        loadingDiv.remove();
        loadDashboard = true;
        smoothScrollTo('body', null, 0);
    } catch (error) {
        console.error('Error setting default address:', error);
        loadingDiv.remove();
    }
}

function cancelAddressForm() {
    const form = document.getElementById('address-form');
    const wrapper = form.closest('.tab-container--wrapper');

    wrapper.style.display = 'none';
    wrapper.querySelector('.user-title').innerHTML = __('add_new_address');

    form
        .querySelectorAll('input:not([name="id_user"])')
        .forEach(input => input.value = '');

    form
        .querySelector('input[name="id_country"]')
        .value = COUNTRY;

    form
        .querySelector('input[name="country"]')
        .value = COUNTRY_NAME;

    form
        .querySelectorAll('input')
        .forEach(input => input
            .closest('div[class^="single-"]')
            ?.classList.remove('validation-wrong')
        );

    form
        .querySelector('input[name="default"]')
        .checked = false;

    form
        .querySelectorAll('input:not([disabled])')
        .forEach(input => input.classList.remove('filled'));

    const errorAddress = form.querySelector('#errorAddress');
    errorAddress.style.display = 'none';
    errorAddress.innerHTML = '';

    window.scrollTo({top: 0, behavior: 'smooth'});
}

async function editAddress(id_address) {
    const form = document.getElementById('address-form');
    const wrapper = form?.closest('.tab-container--wrapper.new-tab');
    if (wrapper) {
        wrapper.style.display = 'flex';
        wrapper.querySelector('.user-title').textContent = __('edit_address');
    }
    const addressElement = document.querySelector(`[id_address="${id_address}"]`);
    const fields = addressElement?.querySelectorAll('[field]');

    fields.forEach(fieldElement => {
        const field = fieldElement?.getAttribute('field');
        if (field) {
            const input = form.querySelector(`input[name="${field}"]`);
            switch (field) {
                case 'region':
                    if (input instanceof HTMLInputElement) {
                        input.value = fieldElement?.textContent ?? '';
                    }
                    let regionInput = form.querySelector(`input[name="${field}"]`);
                    regionInput?.closest('.custom-select')?.querySelector(`li[data-value="${input?.value ?? ''}"]`)?.classList.add('is-selected');
                    regionInput?.closest('.custom-select')?.classList.add('filled');
                    regionInput?.classList.add('filled');
                    break;

                case 'country':
                    form.querySelector(`input[name="id_${field}"]`).value = fieldElement?.getAttribute('id_country');
                    if (input instanceof HTMLInputElement) {
                        input.value = fieldElement?.textContent ?? '';
                    }
                    break;

                case 'default': // default address!
                    if (input instanceof HTMLInputElement) {
                        input.checked = fieldElement?.classList.contains('hidden');
                    }
                    break;

                default: // all other form fields, standard text inputs
                    if (input instanceof HTMLInputElement) {
                        input.value = fieldElement?.textContent;
                        input.dispatchEvent(new Event('change'));
                    }
            }
        }
    });

    const inputIdAddress = form.querySelector(`input[name="id_address"]`);
    if (inputIdAddress) {
        inputIdAddress.value = id_address;
    }
    smoothScrollTo('.tab-container--wrapper.new-tab', null, -80);
}

function checkValidZipcode(inputtxt){
    // Pattern Portugal zipcode
    var regex = new RegExp("^\\d{4}(-\\d{3})?$|^\\d{4}?$"); // XXXX-XXX OR XXXX FORMAT
    return  regex.test(inputtxt.val());
}

/*function saveAddress(form) {
    var id_address = form.id_address.value;
    var action = '/user_address_form/insert';
    var inputs = ['name', 'surnames', 'postcode', 'city', 'address', 'region', 'phone', 'default'];
    var errorAdr = false;

    for (var idx = 0; idx < inputs.length; ++idx) {
        var input = $(form).find('[name="' + inputs[idx] + '"]');
        if (isEmpty($(input).val())) {
            $(input).change();
            $(input).closest('div[class^="single-"]').addClass('validation-wrong');
            errorAdr = true;
        } else if (COUNTRY == 171 && input.attr('name') == 'postcode') {
            if (!checkValidZipcode(input)) {
                $(input).change();
                $(input).closest('div[class^="single-"]').addClass('validation-wrong');
                errorAdr = true;
            }
        }
    }

    if (errorAdr) {
        $('#errorAddress').html('<p>' + __('checkout_error_data') + '</p>').show();
        return false;
    }

    var loadingDiv = ContentLoading();
    $(form).find('button[type="submit"]').attr('disabled', true);
    $.post(action, $(form).serialize(), function (result) {
        if (result.error) { //Address error
            var errorText = '', error;
            for (error in result.error) {
                var input = $('[name="' + error + '"]');
                input.nextAll('.input-validation').removeClass('input-ko').removeClass('input-ok');
                input.nextAll('.input-validation').addClass('input-ko');
                if (errorText == '') errorText = result.error[error]; else errorText = errorText + '<br/>' + result.error[error];
            }
            $(loadingDiv).remove();
            $('#errorAddress').html('<p>' + errorText + '</p>').show();
            $(form).find('button[type="submit"]').attr('disabled', false);
        } else { //Success
            id = id_address != '' ? id_address : result;
            if ($(form.default).prop('checked')) {
                $('#section-account-address').find('.tab-container--wrapper').first().find('.user-box').removeClass('main-option').filter('.check_default').removeClass('hidden');
            }
            $('#errorAddress').html('').hide();
            loadDashboard = true;

            $.post('/modules/user/printInfoAddress', {id_address: id}, function (result) {
                if (id_address) $('[id_address="' + id_address + '"]').replaceWith(result); else $('#section-account-address').find('.tab-container--wrapper').first().prepend(result);

                cancelAddressForm();
                contentLoadingOK(loadingDiv, __('changes_saved'));
                $(form).find('button[type="submit"]').attr('disabled', false);
            });
        }
    }, 'json');

    return false;
}*/

function saveAddress(form) {
    const idAddress = form.id_address.value;
    const inputNames = ['name', 'surnames', 'postcode', 'city', 'address', 'region', 'phone', 'default'];
    let errorAdr = false;

    inputNames.forEach(name => {
        const input = form.querySelector(`[name="${name}"]`);

        let inputValue = input.type === 'checkbox' ? input.checked : input.value;


        if (isEmpty(inputValue)
            || (COUNTRY === 171 && name === 'postcode' && !checkValidZipcode(input))) {
            input.dispatchEvent(new Event('change'));
            const wrapper = input.closest('div[class^="single-"]');
            wrapper?.classList.add('validation-wrong');
            errorAdr = true;
        }
        if (input.type === 'checkbox') {
            form.querySelector(`[name="${name}"]`).value = input.checked ? 1 : 0;
        }
    });

    if (errorAdr) {
        const errorEl = document.getElementById('errorAddress');
        errorEl.innerHTML = `<p>${__('checkout_error_data')}</p>`;
        errorEl.style.display = 'block';
        return false;
    }

    const loadingDiv = ContentLoading();
    const submitButton = form.querySelector('button[type="submit"]');
    submitButton.disabled = true;
    const formData = new URLSearchParams(new FormData(form));

    fetch('/user_address_form/insert?ajax=true', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData
    })
        .then(response => response.text())
        .then(result => {
            if (result.error) {
                let errorText = '';
                Object.keys(result.error).forEach(key => {
                    const input = document.querySelector(`[name="${key}"]`);
                    if (input) {
                        input.parentElement
                            .querySelectorAll('.input-validation')
                            .forEach(valEl => {
                                valEl.classList.remove('input-ko', 'input-ok');
                                valEl.classList.add('input-ko');
                            });
                    }
                    errorText += errorText ? `<br/>${result.error[key]}` : result.error[key];
                });
                loadingDiv.remove();
                const errorEl = document.getElementById('errorAddress');
                errorEl.innerHTML = `<p>${errorText}</p>`;
                errorEl.style.display = 'block';
                submitButton.disabled = false;
            } else {
                const newId = idAddress === '' ? result : idAddress;
                if (form.default.checked) {
                    const section = document.getElementById('section-account-address');
                    const wrapper = section?.querySelector('.tab-container--wrapper');
                    const userBox = wrapper?.querySelector('.user-box');
                    if (userBox) {
                        userBox.classList.remove('main-option');
                        const checkDefaultEl = userBox.querySelector('.check_default');
                        checkDefaultEl?.classList.remove('hidden');
                    }
                }
                const errorEl = document.getElementById('errorAddress');
                errorEl.innerHTML = '';
                errorEl.style.display = 'none';
                loadDashboard = true;

                const formData2 = new URLSearchParams();
                formData2.append('id_address', newId);

                fetch('/modules/user/printInfoAddress?ajax=true', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: formData2
                })
                    .then(response => response.text())
                    .then(htmlResult => {
                        if (idAddress) {
                            const addressElem = document.querySelector(`[id_address="${idAddress}"]`);
                            if (addressElem) {
                                addressElem.outerHTML = htmlResult;
                            }
                        } else {
                            const section = document.getElementById('section-account-address');
                            const wrapper = section?.querySelector('.tab-container--wrapper');
                            wrapper?.insertAdjacentHTML('afterbegin', htmlResult);
                        }
                        cancelAddressForm();
                        contentLoadingOK(loadingDiv, __('changes_saved'));
                        submitButton.disabled = false;
                    });
            }
        })
        .catch(err => {
            console.error(err);
            submitButton.disabled = false;
        });

    return false;
}

function removeAddress(id_address){
    $.post('/modules/user/loadContentModal',
        {template: 'user_confirm', question: __('ask_remove_address'), small_text: __('cant_undone')},
        function (result) {
            contentModal(result);
            $('#confirm-action').click(function(){
                $('#cancel-action').click();
                var loadingDiv = ContentLoading();
                $.post('/user_address_form/deleteUserAddress',
                    {id_address: id_address},
                    function () {
                        var divInfo   = $('[id_address="'+id_address+'"]');
                        divInfo.fadeOut();
                        loadingDiv.remove();
                        loadDashboard = true;
                    });
            });
        }
    );
}

/* INTERESTS & PETS */

function removePet(pet_id){
    $.post('/modules/user/loadContentModal',
        {template: 'user_confirm', question: __('ask_remove_pet'), small_text: __('cant_undone')},
        function (result) {
            contentModal(result);
            $('.popUpContainer-data .button-light.save').addClass('red').css('flex', '0 0 30%');
            $('.popUpContainer-data .button-light.cancel').addClass('green');
            $('.popUpContainer-data .modal-small-text').css('color: red');
            $('#confirm-action').click(function(){
                $('#cancel-action').click();
                var loadingDiv = ContentLoading();
                $.post('/User_Pet/deletePet',
                    {pet_id: pet_id},
                    function (result) {
                        result = json_decode(result);
                        if(result.error){
                            document.location.reload();
                        }else{
                            cancelInterestForm();
                            var divInfo   = $('[id_interest="'+pet_id+'"]');
                            divInfo.fadeOut();
                            loadingDiv.remove();
                            loadDashboard = true;
                        }
                    });
            });
        }
    );
}

function togglePetTypeOptions(petTypeBtnEl, petType, show) {
    if (petTypeBtnEl) {
        if (show) {
            petTypeBtnEl.classList.remove('hidden');
            document.getElementById(petType+'-inputs').classList.remove('hidden');
        } else {
            petTypeBtnEl.classList.add('hidden');
            document.getElementById(petType+'-inputs').classList.add('hidden');
        }
    }
}

function editPet(id_pet){
    $('#id_pet').val(id_pet);
    let horseBtn = document.getElementById('horse');

    $.post('/user_pet/getPetInfo', {id_pet:id_pet}, function(result){
        if(result){
            result = json_decode(result);
            var id_type = result.id_type;

            togglePetTypeOptions(horseBtn, 'horse', false);
            $('.form.interest').closest('.tab-container--wrapper.new-tab').find('.user-title').html(__('edit_pet'));
            $('#content-form').css('display', 'flex');
            $('#content-form').find('.buttons button').show();
            $(window).scrollTop($('.form.interest').offset().top - 230);

            if (id_type == "1") {
                var type = "dog";
                $("#"+type+"-inputs").find("[name='pet-weight']").val(result.info_weight);
                $("#"+type+"-inputs").find("[name='sterilized-pet']").prop('checked', result.castrated);
                $("#"+type+"-inputs").find('input[name="pet-genre"]').each(function(index, value){
                    var genre = parseInt(result.genre);
                    if(index+1 == genre){
                        $(this).prop('checked', true);
                    }
                });
                var id_activity = result.activity;
                if (id_activity == null) id_activity = -1;
                $("#"+type+"-inputs").find("[name='pet-activity']").val(id_activity);
                $("#"+type+"-inputs").find('#'+type+'-activity').find('li').removeClass('is-selected');
                $("#"+type+"-inputs").find('#'+type+'-activity').find('li[data-value="'+id_activity+'"]').addClass('is-selected');
                if (result.filled_activity && id_activity != -1) {
                    $("#" + type + "-inputs").find('#' + type + '-activity').addClass('filled');
                }

            } else if(id_type == "3") {
                var type = "cat";
                var silhouette = result.silhouette;
                if (silhouette == null) silhouette = -1
                $("#"+type+"-inputs").find("[name='pet-weight']").val(result.info_weight);
                $("#"+type+"-inputs").find("[name='sterilized-pet']").prop('checked', result.castrated);
                $("#"+type+"-inputs").find('#'+type+'-silhouette').find('li').removeClass('is-selected');
                $("#"+type+"-inputs").find('#'+type+'-silhouette').find('li[data-value="'+silhouette+'"]').addClass('is-selected');
                if (result.filled_silhouette) {
                    $("#" + type + "-inputs").find('#' + type + '-silhouette').addClass('filled');
                } else {
                    $("#" + type + "-inputs").find('#' + type + '-silhouette').removeClass('filled');
                }

                $("#"+type+"-inputs").find("[name='pet-shape']").val(silhouette);
                $("#"+type+"-inputs").find('input[name="pet-genre"]').each(function(index, value){
                    var genre = parseInt(result.genre);
                    if(index+1 == genre){
                        $(this).prop('checked', true);
                    }
                });

            } else if(id_type == "12") {
                var type = "bird";

            } else if(id_type == "13") {
                var type = "rodent";
                $("#"+type+"-inputs").find('input[name="pet-genre"]').each(function(index, value){
                    var genre = parseInt(result.genre);
                    if(index+1 == genre){
                        $(this).prop('checked', true);
                    }
                });

            } else if(id_type == "14") {
                var type = "fish";

            } else if(id_type == "16") {
                var type = "reptile";

            } else if(id_type == "17") {
                var type = "horse";
                togglePetTypeOptions(horseBtn, type, true);
            }


            $("#"+type).click();

            var image = result.image;
            if(image){
                if(!$("#uploadImg").hasClass("has-image"))$("#uploadImg").addClass("has-image");
                $("#uploadImg").attr("style", "background-image: url("+STATIC_URL+image+")");
                $("#edit").show();
                $("#add").hide();
            }

            $("[name='pet-name']").val(result.pet_name);
            $("#"+type+"-inputs").find("[name='pet-birthdate']").val(result.birthday);
            
            var id_breed = result.id_breed;
            $("#"+type+"-inputs").find("[name='pet-breed']").val(id_breed);
            $("#"+type+"-inputs").find('#'+type+'-breeds').find('li').removeClass('is-selected');
            $("#"+type+"-inputs").find('#'+type+'-breeds').find('li[data-value="'+id_breed+'"]').addClass('is-selected');
            $("#"+type+"-inputs").find('#'+type+'-breeds').addClass('filled');


            var multiselects = ['tastes','care','nutrition','toys'];
            var filledSelects = [result.filled_tastes, result.filled_care, result.filled_nutrition, result.filled_toys]
            multiselects.forEach(function( item, index ) {
                var id = result[item];
                if (id != null) {
                    var arrayIds = id.split(',');
                } else {
                    return;
                }
                var $arrayLi = document.querySelectorAll("#"+type+"-inputs #"+type+"-"+item+" li[data-value]" );
                $("#"+type+"-inputs #"+type+"-"+item).find("[name='multiselect']").val(id);
                $("#"+type+"-inputs").find('#'+type+'-'+item).find('li').removeClass('is-selected'); // reset?
                for (i=0; i<$arrayLi.length; i++) {
                    let idx = $arrayLi[i].dataset.value;
                    if (arrayIds.indexOf( idx ) != -1)
                        $arrayLi[i].classList.add('is-selected');
                }
                if (filledSelects[index]) {
                    $("#" + type + "-inputs").find('#' + type + '-' + item).addClass('filled');
                } else {
                    $("#" + type + "-inputs").find('#' + type + '-' + item).removeClass('filled');
                }
            });

        }

    });
}

function savePet(form){

    var action     = '/user_pet/insert';
    var loadingDiv = ContentLoading();
    var form_data = new FormData(form);

    if(form_data.get('id_pet') == 'undefined'){
        form_data.set('id_pet', '0');
    }

    $.ajax({
        url: action,
        data: form_data,
        processData: false, contentType: false, type: 'POST'
    }).then(function(res){
        res = json_decode(res);
        if(res.error){
            $('#errorMessage').html(res.error).show();
            contentLoadingKO(loadingDiv, res.error);
        }else{
            var id_pet = res.id_pet;
            var edit   = res.edit;
            $.post('/user_pet/printInfoPet',
                {id_pet: id_pet},
                function (html) {
                    if(edit) $('[id_interest="'+id_pet+'"]').replaceWith(html);
                    else {
                        $('#section-interests-index').find('#boxes').first().prepend(html);                        
                    }
                    cancelInterestForm();
                    contentLoadingOK(loadingDiv, __('changes_saved'));
                    $(form).find('button[type="submit"]').attr('disabled', false);
                }
            );
        }
    }).fail(function (res) {
        if (!res.error) {
            $('#errorMessage').html(__('process_error_try_again')).show();
        }
        loadingDiv.hide();
    }).done(function(){
        document.location.reload();
        showMenu('interests','');
    });
    
    return false;
}

function chooseAsPrincipal(pet_id){
    var loadingDiv = ContentLoading();
    $.post('/User_Pet/chooseAsPrincipal',
        {pet_id: pet_id},
        function (result) {
            if(!result){
                document.location.reload();
            }else{
                $('#section-interests').find('.user-box').removeClass('main-option');
                $('#section-interests').find('.user-box').find('.check_default').removeClass('hidden');
                $('[id_interest="'+pet_id+'"]').addClass('main-option').find('.check_default').addClass('hidden');
                loadingDiv.remove();
                loadDashboard = true;
            }
        });
}

function cancelInterestForm(){
    $('.form.interest').closest('.tab-container--wrapper').hide();
    $('.form.interest').find('input:not([type=radio])').val('');
    $('.form.interest').find('input').prop('checked', false);
    $('.form.interest').find('li.is-selected').removeClass('is-selected');
    $('.button-interest').removeClass('is-selected');
    $('#specific-inputs').removeClass('is-visible');
    $('#errorMessage').html('');
    $('html').scrollTop(0);
    $("#uploadImg").removeClass("has-image");
    $("#add").show();
    $("#edit").hide();
    $('.form.interest').closest('.tab-container--wrapper').find('.user-title').html(__('add_new_pet'));
    // $("#uploadImg").css('background-image', 'none');
}

function cancelRecommendedProds(){
    $('#recommended-products').hide();
    $('html').scrollTop(0);
}


function showRecommendedProds(id_pet){
    $('#id_pet').val(id_pet);
    $.post('/user_pet/getPetInfo', {id_pet:id_pet}, function(result){
        if (result){
            result = json_decode(result);
            $('#recommended-products').css('display', 'flex');
            $(window).scrollTop($('#recommended-products').offset().top - 100);
        }
    });
}

function updateNewsLetterActive() {
    $.post('/user_form/updateSubscriptions',
        {newsletter: 1, type_personalized: 1, type_coupons: 1, type_brands: 1},
        function () {
            document.location.reload();
    });
}

/* SUBSCRIPTIONS */
function cancelSubscriptionInfo(){
    $('.form.subscriptions').find('input').each(function(){
        if($(this).attr('type') == 'checkbox'){
        var value = $(this).attr('data-original') == '1' ? true : false;
        $(this).prop('checked', value);
        }
    });
    $('.form.subscriptions').find('.buttons button').hide();
}

function updateSubscriptions(form){
    var loadingDiv = ContentLoading();
    $.post(form.action,
    $(form).serialize(),
    function (result) {
        if (!result.error) {
            $('.form.subscriptions').find('input').each(function(){
                if($(this).attr('type') == 'checkbox'){
                    var value = $(this).prop('checked') ? 1 : 0;
                    $(this).attr('data-original', value);
                }
                });
            $('.form.subscriptions').find('.buttons button').hide();
            contentLoadingOK(loadingDiv, result.success);
            _debounceFn(() => document.location.reload(), 1000)();
        } else {
            contentLoadingKO(loadingDiv, result.error);
        }
    },
    'json');

    return false;
}

/* CARDS */
// MIS-1160: Save credit cards if autoship order
function updateSaveCards(form){
    var loadingDiv          = ContentLoading();
    var $userSaveCards      = $('.form.user_save_cards');
    var $userSaveCardsInput = $('#user_save_cards');

    $.post(form.action,
    $(form).serialize(),
    function (result) {
        if (!result.error) {
            if($userSaveCardsInput.attr('type') == 'checkbox') {
                var value = $userSaveCardsInput.prop('checked') ? 1 : 0;
                $userSaveCardsInput.attr('data-original', value);
            }

            $userSaveCards.find('.buttons button').hide();
            contentLoadingOK(loadingDiv, result.success);
        } else {
            contentLoadingKO(loadingDiv, result.error);
        }
    },
    'json');

    return false;
}

function cancelSaveCards(){
    var $userSaveCards  = $('.form.user_save_cards');
    var $saveCardsInput = $('#user_save_cards');

    $saveCardsInput.each(function() {
        if( $(this).attr('type') == 'checkbox')  {
            var value = $(this).attr('data-original') == '1' ? true : false;
            $(this).prop('checked', value);
        }
    });
    $userSaveCards.find('.buttons button').hide();
}


/* CARDS */
function removeCard(id){
    if (PAYMENT_METHOD === 'stripe'){
        removeCardStripe(id);
    }
}
function checkDefaultCard(id){
    if (PAYMENT_METHOD === 'stripe'){
        checkDefaultCardStripe(id);
    }
}

function removeCardStripe(card_id){
    $.post('/modules/user/loadContentModal',
        {template: 'user_confirm', question: __('ask_remove_card'), small_text: __('cant_undone')},
        function (result) {
            contentModal(result);
            $('#confirm-action').click(function(){
                $('#cancel-action').click();
                var loadingDiv = ContentLoading();
                $.post('/TPV_Stripe/detachPaymentMethod',
                    { card_id: card_id },
                    function (result) {
                        console.log(result);
                        if (!result || result.error) {
                            contentLoadingKO(loadingDiv, result.error ||__('process_error_try_again'));
                        } else {
                            var divInfo   = $('[id_card="'+card_id+'"]');
                            divInfo.fadeOut();
                            loadingDiv.remove();
                            loadDashboard = true;
                        }
                    },
                    'json'
                );
            });
        }
    );
}

function checkDefaultCardStripe(card_id){
    var loadingDiv = ContentLoading();
    $.post('/TPV_Stripe/setUserDefaultCard',
        { card_id: card_id },
        function (result) {
            if (!result || result.error) {
                contentLoadingKO(loadingDiv, result.error || __('process_error_try_again'));
            } else {
                $('#section-account-payment').find('.user-box').removeClass('main-option');
                $('#section-account-payment').find('.user-box').find('.check_default').removeClass('hidden');
                $('[id_card="'+card_id+'"]').addClass('main-option').find('.check_default').addClass('hidden');
                loadingDiv.remove();
                loadDashboard = true;
            }
        },
        'json'
    );
}

/* REVIEWS */
function saveReview(form){
    var loadingDiv = ContentLoading();
    $.post(form.action,
    $(form).serialize(),
    function (result) {
        if (!result.error) {
            starRating = 0;
            $('[id_prod="'+form.id_product.value+'"]').fadeOut();
            contentLoadingOK(loadingDiv, __('changes_saved'));
            $.post('/modules/user/printInfoReview/'+result,
                function (result) {
                $('.products-reviewed').append(result);
            });
        } else {
            contentLoadingKO(loadingDiv, result.error);
        }
    },
    'json');

    return false;
}

function goToReviews(elem){
    var order   = $(elem).closest('.user-box');
    var id_prod = $(order).find('article[to_review="true"]').first().attr('id_prod');
    changeUserSubMenu('orders-reviews');
    setTimeout(function () {
        $(window).scrollTop($('#section-orders-reviews').find('[id_prod="'+id_prod+'"]').offset().top - 180);
    }, 250);
}

function initStars(){
  /* STARS RATING*/
    $(".write-review--star-ratings .star").hover(
        function(e) {
        //Add yellow colour to current and previous stars
        var hoveredStars = $(this).prevAll().add(this);
        hoveredStars.addClass("hovered");
        //Remove yellow caused by rated stars so that the hovering shows the new potential rating
        var allStars = $(this).siblings().add(this);
        allStars.removeClass("rated-star");
        },
        function(e) {
        //Remove all yellow caused by hovering
        var allStars = $(this).siblings().add(this);
        allStars.removeClass("hovered unhovered");
        //Add back yellow caused by rated stars to the correct number of rated stars
        allStars.slice(0, starRating).addClass("rated-star");
        }
    );

    $(".write-review--star-ratings .star").click(function(e) {
        //Removes the rated-star class from all stars in case a rating was provided earlier
        var allStars = $(this).siblings().add(this);
        allStars.removeClass("rated-star");
        //Adds the the rated-star class to the stars corresponding with the clicked rating
        var hoveredStars = $(this).prevAll().add(this);
        hoveredStars.addClass("rated-star");

        //Update the starRating variable with the new rating
        starRating = hoveredStars.length;
        var form = $(this).closest('.product-review').find('form').first();
        if(form) $(form).find('input[name="rate"]').val(starRating);

        $(this).closest('.product-review').addClass('is-open');
    });
}

function loadMoreOrders(elem, pag){
    var loadingDiv = ContentLoading();
    $.post('/modules/user/loadMoreOrders/'+pag,
        function (result) {
        $(elem).remove();
        $('#orders_list').append(result);

        var iniIndex = ((pag-1)*5);
        var endIndex = iniIndex + 5;

        $('#orders_list').parent().find('.user-box--header .header-trigger:not(.cancel)').slice(iniIndex,endIndex).click(function() {
            $(this).parent('.user-box--header').toggleClass('is-open');
        });
        $('#orders_list').parent().find('.user-box--header .header-trigger.cancel').slice(iniIndex,endIndex).click(function() {
            $(this).parents('.user-box').toggleClass('config-on');
        });
        $('.order--more-items').slice(iniIndex,endIndex).click(function() {
            $(this).parents('.user-box').removeClass('has-more');
        });
        loadingDiv.remove();
    });
}

function loadMoreReviews(elem, pending, pag){
    var loadingDiv = ContentLoading();
    $.post('/modules/user/loadMoreReviews/'+pending+'/'+pag,
        function (result) {
        $(elem).remove();
        if(pending){
            $('.products-to-review').append(result);
            initStars();
        }else{
            $('.products-reviewed').append(result);
        }
        loadingDiv.remove();
    });
}

/**
 * Helper function for prdStatusAutoship function as
 * in this case we do not need ( for now ) a popup
 * with confirmation.
 *
 * @param {*} id_autoshipping
 * @return {boolean}
 */
function resumeAutoShip(id_autoshipping){
    var loadingDiv = ContentLoading();
    $.post('/order_autoship_form/prdStatusAutoship',
      {idAutoshipping: id_autoshipping, status: 1, calculateDate: 1},
      function (result) {
        if(!result){
          document.location.reload();
        }else{
          loadDashboard = true;
          refreshAutoshipping(id_autoshipping, loadingDiv, false);
          return true;
        }
    });
}


/**
 * Function that updates the shipping status, allowing to
 * pause, resume or cancel/delete.
 *
 * @param {*} id_autoshipping id to update current status.
 * @param {*} status name of the status setted in switch.
 * @param type
 * @return {void}
 */
function prdStatusAutoship(id_autoshipping, status, type){
    switch (status) {

        case 'pause':
            status = 2;
            var tag0; var tag1; var tag2; var tag3; var tag4; var tag5; var tag6; //Autoship Benefits Key Concepts/Values TAGS per Shop
            switch(SHOP_ID) {
                case '9':
                case '10':
                    tag0 = __('ask_pause_autoship_ani');
                    tag1 = __('autoship_clam_ani_1');
                    tag2 = __('autoship_clam_ani_2');
                    tag3 = __('autoship_clam_ani_3');
                    tag4 = __('autoship_clam_ani_4');
                    tag5 = __('autoship_can_change_ani');
                    tag6 = __('autoshipping_paused_ani');
                    break;

                default:  // default --> Miscota, Maskokotas...
                    tag0 = __('ask_pause_autoship');
                    tag1 = __('autoship_benefits_1');
                    tag2 = __('autoship_benefits_2');
                    tag3 = __('autoship_benefits_3');
                    tag4 = __('autoship_benefits_4');
                    tag5 = __('autoship_can_change');
                    tag6 = __('autoshipping_paused');
            };

            ext_content = "<span class='autoship-bg-image'></span>" +
                "<ul class=autoship-benefits>" +
                    "<li class='icon2-check-1 cian-check'>" + tag1 + "</li>" +
                    "<li class='icon2-check-1 cian-check'>" + tag2 + "</li>" +
                    "<li class='icon2-check-1 cian-check'>" + tag3 + "</li>" +
                    "<li class='icon2-check-1 cian-check'>" + tag4 + "</li>" +
                "</ul>" +
                "<p class='modal-bottom-text'>" + tag5 + "</p>";

            $.post('/modules/user/loadContentModal',
                {template: 'user_confirm', question: tag0, small_text: __('pause_autoship_smalltext'), ext_content: ext_content },
                function (result) {
                    /* CONFIRM POPUP */
                    contentModal(result);
                    $('.modal-main-question').addClass('big');
                    $('.modal-small-text').attr('style', 'color: '+ (SHOP_ID == 11 ? 'var(--primary)' : '#f34336') +';font-weight: 500;margin-top: 12px;margin-bottom: -3px;text-transform: uppercase;letter-spacing: 1px;font-size: 11px');
                    $('#confirm-action').addClass('red');
                    $('#cancel-action').toggleClass('cancel cancel-gray');

                    $('#confirm-action').click(function(){
                        $('#cancel-action').click();
                        /* SHOW LOADING */
                        var loadingDiv = ContentLoading();

                        $.post('/order_autoship_form/prdStatusAutoship',
                            {idAutoshipping: id_autoshipping, status: status},
                            function (result) {

                            if(!result){
                                document.location.reload();
                            } else {
                                loadDashboard = true;
                                refreshAutoshipping(id_autoshipping, loadingDiv, false);
                            }
                            contentLoadingOK(loadingDiv, tag6);
                        });
                    });
                });
            break;

        case 'resume':
            return resumeAutoShip(id_autoshipping);

        case 'cancel':
            status = 255;
            var tag10; var tag11; //Autoship CANCEL/DELETE TAGS per Shop
            switch(SHOP_ID) {
                case '9':
                case '10': tag10 = __('ask_cancel_autoship_ani'); tag11 = __('autoshipping_deleted_ani'); break;
                default: tag10 = __('ask_cancel_autoship'); tag11 = __('autoshipping_deleted');   // default --> Miscota, Maskokotas...
            };
            $.post('/modules/user/loadContentModal',
                {template: 'user_confirm', question: tag10, small_text: __('cant_undone')},
                function (result) {
                    /* CONFIRM POPUP */
                    contentModal(result);
                    $('#confirm-action').addClass('red');
                    $('#cancel-action').toggleClass('cancel cancel-gray');

                    $('#confirm-action').click(function(){
                        $('#cancel-action').click();
                        /* SHOW LOADING */
                        var loadingDiv = ContentLoading();
                        $.post('/order_autoship_form/prdStatusAutoship',
                            {
                                idAutoshipping: id_autoshipping,
                                status: status,
                                type:type
                            },
                            function (result) {
                            if(!result){
                                document.location.reload();
                            } else {
                                loadDashboard = true;
                                refreshAutoshipping(id_autoshipping, loadingDiv);
                            }
                            contentLoadingOK(loadingDiv, tag11);
                        });
                        setTimeout(function(){
                            $('.user-box.autoship[id_autoshipping='+ id_autoshipping +']').addClass('autoship-deleted');
                        },4000);

                    });
                });
            break;

        default: return false;
    }

}

function cancelAutoShip(id_autoshipping){
    $.post('/modules/user/loadContentModal',
       {template: 'user_confirm', question: __('ask_cancel_autoship'), small_text: __('can_cancel')},
       function (result) {
          contentModal(result);
          $('#confirm-action').click(function(){
              $('#cancel-action').click();
              var loadingDiv = ContentLoading();
              $.post('/order_autoship_form/prdStatusAutoship',
                {idAutoshipping: id_autoshipping, status: 255},
                function (result) {
                  if(!result){
                    document.location.reload();
                  }else{
                    loadDashboard = true;
                    refreshAutoshipping(id_autoshipping, loadingDiv);
                  }
              });
          });
       }
    );
}

function sendOrderNow(id_autoshipping){
    $.post('/modules/user/loadContentModal',
        {template: 'user_confirm', question: __('ask_confirm_order'), small_text: __('order_promo_applied')},
        function (result) {
            contentModal(result);
            $('.modal-message').toggleClass('red green').toggleClass('icon2-report-problem-circle icon2-check-1');

            $('#confirm-action').click(function(){
                $('#cancel-action').click();
                var loadingDiv = ContentLoading();
                $.post('/order_autoship_form/sendNowAutoshippings',
                {idAutoshipping: [{ 'id_autoshipping': id_autoshipping}] },
                function (result) {
                    if(!result){
                        document.location.reload();
                    }else if(result.error){
                        contentLoadingKO(loadingDiv, result.error);
                    }else{
                        loadDashboard = true;
                        refreshAutoshipping(id_autoshipping, loadingDiv);
                    }
                }, 'json');
            });
        }
    );
}

function saveAutoshipAddress(form){
    var id_autoshipping = form.id_autoshipping.value;
    var action          = '/user_address_form/saveUserAddressAutoShipping';
    var inputs          = ['name', 'surnames', 'postcode', 'city', 'address', 'region', 'phone'];
    var errorAdr        = false;

    for (var idx = 0; idx < inputs.length; ++idx) {
        var input = $(form).find('[name="'+inputs[idx]+'"]');
        if(isEmpty($(input).val()) ){
        $(input).change();
        $(input).closest('div[class^="single-"]').addClass('validation-wrong');
        errorAdr = true;
        }
    }

    if(errorAdr){
        $('#errorAddress').html('<p>'+__('checkout_error_data')+'</p>').show();
        return false;
    }

    var loadingDiv = ContentLoading();
    $(form).find('button[type="submit"]').attr('disabled', true);
    $.post(action,
    $(form).serialize(),
    function (result) {
        if(result.error){ //Address error
            var errorText = '';
            for (error in result.error) {
                var input = $('[name="'+error+'"]');
                input.nextAll('.input-validation').removeClass('input-ko').removeClass('input-ok');
                input.nextAll('.input-validation').addClass('input-ko');
                if (errorText == '') errorText = result.error[error];
                else errorText = errorText + '<br/>' + result.error[error];
            }
            $(loadingDiv).remove();
            $('#errorAddress').html('<p>'+errorText+'</p>').show();
            $(form).find('button[type="submit"]').attr('disabled', false);
        }else{ //Success
            loadDashboard = true;
            $(form).closest('.popUpContainer-data').remove();
            refreshAutoshipping(id_autoshipping, loadingDiv);
        }
    }, 'json');

    return false;
}

function refreshAutoshipping(id_autoshipping, loadingDiv, openAutoship){

    /* Used this instead default funct params IE11 compatiblity.... */
    if (typeof openAutoship === 'undefined') openAutoship = $("[id_autoshipping="+id_autoshipping+"]").is(".config-on");

    return $.post('/modules/user/printInfoAutoship',
        {id_autoshipping: id_autoshipping, key: $('[id_autoshipping="'+id_autoshipping+'"]').attr('key')},
        function (result) {
            $('[id_autoshipping="'+id_autoshipping+'"]').replaceWith(result);
            $('[id_autoshipping="'+id_autoshipping+'"]').find('.user-box--header .header-trigger').click(function() {
                $(this).parent('.user-box--header').toggleClass('is-open');
                $(this).parents('.user-box').toggleClass('config-on');
            });
            if(openAutoship) $('[id_autoshipping="'+id_autoshipping+'"]').find('.user-box--header .header-trigger').click();
            if(loadingDiv) contentLoadingOK(loadingDiv, __('changes_saved'));
        }
    );
}

/**
 * This functions references deleteItemAutoship.
 * It handles confirmation before deleting the autoship item (prev confirmation).
 *
 * @param {*} id_autoshipping Id of the autiship.
 * @param {*} id_product Id of the product to delete.
 * @param {*} ref Reference (unique id) of the prod.
 */
function deleteItemAutoship(id_autoshipping, id_product, ref){
    $.post('/modules/user/loadContentModal',
        {template: 'user_confirm', question: __('ask_remove_item_autoship'), small_text: __('cant_undone')},
        function (result) {
            contentModal(result);

            $('#confirm-action').addClass('red');
            $('#cancel-action').toggleClass('cancel cancel-gray');

            $('#confirm-action').click(function(){
                $('#cancel-action').click();
                var loadingDiv = ContentLoading();
                $.post('/modules/user/deleteItemAutoship',
                    {
                        id_autoshipping: id_autoshipping,
                        id_product: id_product,
                        ref: ref
                    },
                    function (result) {
                        loadDashboard = true;
                        refreshAutoshipping(id_autoshipping, loadingDiv);
                        contentLoadingOK(loadingDiv,__('removed_item_autoship'));
                    }
                );
            });
        }
    );
}

function changeAddressAutoShipping(id_autoshipping){
    $.post('/modules/user/printChangeAddressAutoship',
        {id_autoshipping: id_autoshipping},
        function (result) {
            var div = contentModal(result, __('change_address'));
            $('body.is-mobile').css('position', 'fixed');
            $('#autoship_address').find('input').on('keyup change', function(e) {
                var input = $(this);
                if (input.val().length > 0) {
                    input.addClass('filled');
                    $(input).closest('div[class^="single-"]').removeClass('validation-wrong');
                } else if ($(input).attr('name') != 'password'){
                    input.removeClass('filled');
                }
            });
            $('#autoship_address').find('.buttons button').show();
            $(".custom-select").each(function(){
                new CustomSelect(this);
            });

            if(!MOBILE) $(div).find('.data-wrapper').addClass('oVisible');
        }
    );
}

function changeDateNextDeliver(id_autoshipping){
    $.post('/modules/user/printChangeNextDeliver',
        {id_autoshipping: id_autoshipping},
        function (result) {
            var div = contentModal(result, __('change_date_deliver'));
            $(".custom-select").each(function(){
                new CustomSelect(this);
            });
            $('#autoship_deliver').find('.buttons button').show();

            $(div).find('.data-wrapper form').addClass('oVisible');
            $(div).find('.data-wrapper').addClass('oVisible');
        }
    );
}

function saveAutoshipNextDeliver(form){
    var id_autoshipping = form.id_autoshipping.value;
    var action          = '/order_autoship_form/changeNextDeliverDate';

    var loadingDiv = ContentLoading();
    $(form).find('button[type="submit"]').attr('disabled', true);
    $.post(action,
    $(form).serialize(),
    function (result) {
        if(!result){
            document.location.reload();
        }else{
            loadDashboard = true;
            $(form).closest('.popUpContainer-data').remove();
            refreshAutoshipping(id_autoshipping, loadingDiv);
            contentLoadingOK(loadingDiv, __('updated_autoship_next_deliver'));
        }
    }, 'json');

    return false;
}

/**
 * Looks for the most repeated category on selected autoshipping order.
 *
 * @param {*} button this button html.
 */
function customUrlItemBased(button){
    var base_array = [];
    var counts = [];
    var wwcd = 0;
    var most_repeated = "";
    var selected_autoship = $(".autoship[id_autoshipping="+$(button).attr("idao_ref")+"]");

    $(selected_autoship).find(".order--items > .order--single-item").each(function(index, single){
        var dataCat = single.getAttribute("datacat");
        base_array.push(dataCat);
    });

    base_array.forEach(function(x) {
        counts[x] = (counts[x] || 0) + 1;
        if(wwcd < counts[x]){
            most_repeated = x;
            wwcd = counts[x];
        }
    });

    /* Now we setup the url manually so it opens the most common cat in this autoshipping */
    $(selected_autoship).find(".autoship--add-more-items button").attr("onclick","document.location.href='/"+most_repeated+"'");


}

function updateFreqTime(ev){
    ev.preventDefault();
    var form = this;
    var id_autoshipping = form.id_autoshipping.value;
    var action          = '/order_autoship_form/updateFreqTime';
    var loadingDiv = ContentLoading();
    var frequency = $(form).find('#autoship-frequency').val();

    $(form).find('button[type="submit"]').attr('disabled', true);

    $.post(action,
    {
        idAutoshipping: id_autoshipping,
        frequency: frequency
    },
     function (result) {
        if(!result){
          document.location.reload();
        }else{
          loadDashboard = true;
          $(form).closest('.popUpContainer-data').remove();
          refreshAutoshipping(id_autoshipping, loadingDiv);
        }
     }, 'json');

    return false;
}

function changeAutoshipFrequency(id_autoshipping){
    return $.post('/modules/user/printUpdateFreqTime',
        {id_autoshipping: id_autoshipping},
        function (result) {
            var div = contentModal(result, __('change_the_shipping_frequency'));
            $(div).addClass("modal-autoship-frequency").find("form").on("submit", updateFreqTime);
            $('#autoship_frequency_modal').find('.buttons button').show();
            if (!MOBILE) $(div).find('.data-wrapper').addClass('oVisible');
        }
    );
}


/**
 * Making generic for increment input.
 * Do not allow input greater than limit
 *
 * @param {object} button_element
 */
function incrementOne(button_element, limit= MAX_FREQUENCY, showError= true) {
    if(button_element.parentNode.querySelector('input').value >= limit) {
        if (showError) {
            contentModalMsg(___('maximum_frequency_limit',{maxFrequency: limit}), 'error');
        }
        button_element.parentNode.querySelector('input').value=limit;
    } else {
        button_element.parentNode.querySelector('input').value++;
    }    
}

/**
 * Making generic for increment input.
 * Do not allow input lower than limit.
 *
 * @param {object} button_element
 */
function decrementOne(button_element, limit= MIN_FREQUENCY, showError= true) {
    if(button_element.parentNode.querySelector('input').value <= limit) {
        if (showError) {
            contentModalMsg(___('minimum_frequency_limit',{minFrequency: limit}), 'error');
        }        
        button_element.parentNode.querySelector('input').value=limit;
    } else {
        button_element.parentNode.querySelector('input').value--;
    }    
}

/**
 * Making generic for set input.
 * Do not allow input lower than 1.
 *
 * @param {object} button_element
 */
 function setInputValue(button_element, minLimit= MIN_FREQUENCY, maxLimit= MAX_FREQUENCY) {
    if(button_element.parentNode.querySelector('input').value < minLimit) {
        decrementOne(button_element, minLimit, false)
       
    } else if(button_element.parentNode.querySelector('input').value > maxLimit) {
        incrementOne(button_element, maxLimit, false)
    }    
}

/**
 *
 * Calls the update quantity, of product in autoship.
 *
 * @param {*} id_autoshipping default null
 * @param {*} id_product default null
 * @param {*} ref default null
 * @param {*} opt *required ( + or - or M `Manual`);
 * @param {object} btn_element *required
 * @return {boolean} true/false if op went well or not.
 */
function updateAutoshipQty(id_autoshipping, id_product, ref, opt, btn_element){

    /* Used this instead default funct params IE11 compatiblity.... */
    if (typeof id_autoshipping === 'undefined') id_autoshipping = null;
    if (typeof id_product === 'undefined') id_product = null;
    if (typeof ref === 'undefined') ref = null;

    /* Check with option is set, if not set properly, return false */
    if(opt === "+"){
        incrementOne(btn_element, 99, false);
    } else if(opt === "-"){
        decrementOne(btn_element, 1, false);
    } else if(opt === "M") {
        setInputValue(btn_element, 1, 99);
    } else if(opt !== "M") {
        return false;
    }

    /* check if params are NOT NULL if are, do not proceed just update visually */
    if(id_autoshipping === null || id_product === null || ref === null) return false;

    /* We lock the buttons (all of them) to prevent simultaneously */
    $('.more-button').css("pointer-events", 'none');
    $('.less-button').css("pointer-events", 'none');

    /* Add a bit of timeout to prevent input being submitted before it changes */
    // Get the new value.
    var newQty = btn_element.parentNode.querySelector('input').value;

    var loadingDiv = ContentLoading();
    $.post('/modules/user/updateAutoshipProductQuantity',
        {
            id_autoshipping: id_autoshipping,
            id_product: id_product,
            ref: ref,
            qty: newQty
        },
        function (result) {
            refreshAutoshipping(id_autoshipping, loadingDiv);
            setTimeout(function(){
                loadDashboard = true;
                contentLoadingOK(loadingDiv, __('changes_saved'));
            },500);
            /* We unlock the buttons (all of them) to prevent simultaneously */
            $('.more-button').css("pointer-events", '');
            $('.less-button').css("pointer-events", '');
        }
    );
}


/* MIS-614 :: Modal +300 points reward for Old Animalear Users (not logged) */
function addUserPointsModal() {
    var data =
        '<div class="reward-wrapper">' +
            '<h3 class="reward-header">¡Te regalamos 3€ en puntos!</h3>' +
            '<div class="reward-content">' +
                '<img src="'+STATIC_URL+'/media/9/assets/images/corp/landing_puntos_que-son_punto.png">' +
                '<p class="bold-text">300 puntos</p>' +
                '<p>Para que los disfrutes en lo que quieras</p>' +
                '<button class="button-light save" id="acceptPoints">' +
                    '<div class="button-wrapper">' +
                        '<p class="button-text">Canjear puntos</p>' +
                    '</div>' +
                '</button>' +
            '<div>' +
        '</div>'
    ;

    contentModal(data);
    $('.reward-wrapper').closest('.data-wrapper').addClass('reward-modal');
    $('#acceptPoints').on('click', function() {
        if(typeof show_reward_points !== 'undefined'){
            if(show_reward_points !== null) show_reward_points = null;
        };

        setTimeout(function(){
            $('.reward-modal').find('.close-button').click();
        },300);

    });

    $('#section-points').find('.user-box--content').css('display', 'block').append('<p class="points-msg">' + __('points_reward_msg') + '</p>');
}

/* End of file -------------------------------- */
/* -------------------------------------------- */

